import React from "react";
import "./JobItem.css";

const JobItemSkeleton = () => {
    return (
        <div className="job_item_skeleton">
            <div className="job_item_skeleton_content">
                <div className="job_item_skeleton_title"></div>
                <div className="job_item_skeleton_line"></div>
                <div className="job_item_skeleton_line short"></div>
                <div className="job_item_skeleton_line"></div>
                <div className="job_item_skeleton_line short"></div>
            </div>
        </div>
    );
};

export default JobItemSkeleton;
